module.exports = __webpack_public_path__ + "static/img/hb_27-min.7af0846.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_27-min.png
// module id = vGF/
// module chunks = 1